import React from 'react';
import { LocationPage } from './useLocationPage';
import './useLocationPage.css';

// ─── Images ───────────────────────────────────────────────────────────────────
// Swap out any of these for Sarasota-specific shots
import heroImg   from '../images/tampa3.webp';
import bgImg     from '../images/image8.webp';
import slideImg1 from '../images/image121.webp';
import slideImg2 from '../images/image117.webp';
import slideImg3 from '../images/image50.webp';

// ─── Config ───────────────────────────────────────────────────────────────────
const citrusParkConfig = {

  /* ── SEO ────────────────────────────────────────────────────────────────── */
  pageTitle:       'Citrus Park Tree Service | Sam\'s Tree Service',
  metaDescription: 'Expert tree trimming and removal in Citrus Park, FL. Sam\'s Tree Service handles dangerous trees safely and professionally.',
  canonicalUrl:    'https://samstreeservice.com/tree_service_citrus_park',

  /* ── Hero ───────────────────────────────────────────────────────────────── */
  heroHeading: 'Serving Citrus Park',
  heroImageUrl: heroImg,
  bgImageUrl:   bgImg,

  /* ── Slide images ───────────────────────────────────────────────────────── */
  slideImage1: slideImg1,
  slideImage2: slideImg2,
  slideImage3: slideImg3,

  /* ── Main text panel ────────────────────────────────────────────────────── */
  sectionHeading: 'Professional Tree Service in Citrus Park Specializing In Dangerous Trees',

  paragraphs: [
    `At <strong>Sam's Tree Service</strong>, we bring expert tree care to the 
     residential subdivisions and growing communities of <strong>Citrus Park</strong>. 
     Located in Northwest Hillsborough County, this area has seen rapid growth
     and with that growth comes maturing trees that increasingly threaten rooftops, 
     fences, and utility infrastructure. Our team handles those hazards before 
     they become expensive problems.`,

    `We specialize in <strong>hazardous tree removal and precision trimming in 
     active suburban communities</strong> large overhanging limbs near newer 
     homes, storm damaged trees, palms with root or trunk issues, and canopy 
     reductions that keep your property safe and your HOA happy. We work 
     cleanly and efficiently on every job.`,

    `<strong>Sam's Tree Service</strong> delivers reliable, affordable tree care 
     throughout <strong>Citrus Park</strong> and surrounding 
     <strong>Northwest Hillsborough</strong> communities keeping your home 
     and neighborhood safe through every storm season.`,
  ],
  ctaLabel: 'Request An Appointment',

  /* ── Service buttons (optional — defaults to the 4 standard ones) ────────── */
  // serviceButtons: [
  //   { label: 'Tree Trimming', to: '/tree_trimming' },
  //   { label: 'Tree Removal',  to: '/tree_removal'  },
  //   { label: 'Stump Removal', to: '/stump_removal'  },
  //   { label: 'Debris Hauling',to: '/debris_hauling' },
  // ],

  /* ── Google Map ─────────────────────────────────────────────────────────── */
  mapCity: 'Citrus Park, FL',
};

// ─── Page ─────────────────────────────────────────────────────────────────────
const Services_CitrusPark = () => <LocationPage config={citrusParkConfig} />;
export default Services_CitrusPark;
